jQuery(function ($) {
    // Navigaation js-hommat
    function navMenu() {
        $(".menu-toggle").click(function () {
            $("#nav-icon").toggleClass("open");
            $("body").toggleClass("ovfhidden");
            $("#site-navigation").toggleClass("toggled");

            if ($("nav").hasClass("toggled")) {
                $(this).attr("aria-expanded", "true");
                $(this).attr("aria-label", "Sulje menu");
            } else {
                $(this).attr("aria-expanded", "false");
                $(this).attr("aria-label", "Avaa menu");
            }
        });
        // Check if click was triggered on or within #menu_content
        $(document).click(function (e) {
            if ($(e.target).closest("#site-navigation").length == 0) {
                $("#site-navigation").removeClass("toggled");
                $("body").removeClass("ovfhidden");
                $("#nav-icon").removeClass("open");
            }
        });

        // sulkee mobilemenun sivun kokoa muutettaessa
        $(window).on("resize", function () {
            $("#site-navigation").removeClass("toggled");
            $("body").removeClass("ovfhidden");
            $("#nav-icon").removeClass("open");
            //equalHeight('.fp-hl-inner');
        });

        // Navigation sub-menus
        $(".menu-item-has-children").prepend(
            '<button id="sub-menu-button" class="sub-menu-button"></button>'
        );
        $(".sub-menu-button").click(function () {
            if ($(this).siblings(".sub-menu").hasClass("open")) {
                //$(this).text('+');
                $(this).removeClass("sub-menu-button-open");
                $(this).siblings(".sub-menu").removeClass("open");
            } else {
                //$(this).text('-');
                $(this).addClass("sub-menu-button-open");
                $(this).siblings(".sub-menu").addClass("open");
            }
        });
    }

    function fixedNav() {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 200) {
                // > 40px from top - show div
                $("#scroll-to-top").addClass("scroll-to-top-visible");
                $(".header-top-bar").addClass("fixed-scroll");
            } else {
                // <= 40px from top - hide div
                $("#scroll-to-top").removeClass("scroll-to-top-visible");
                $(".header-top-bar").removeClass("fixed-scroll");
            }
        });
    }

    // Avaa togglen jos siihen on linkitetty
    function openSingleToggleFromUrl() {
        // Tarkistetaan onko URL:ssa ankkurilinkityksiä
        if (location.hash) {
            // Haetaan URL:sta ankkuri
            var hash = location.hash;
            var strippedHash = hash.replace("#", "");
            // Haetaan getHash muuttujaan .toggle-content-menu-header ID
            var geThash = $("#" + strippedHash + ".target-header").attr("id");
            // Animaation nopeus
            var animSpeed = 800;
            // Scrollauksen offset
            var offSet = 400;

            // Vertaillaan URL:n ankkuria onko .toggle-content-menu-header sama ID arvo
            if (strippedHash == geThash) {
                // haetaan missä kohdassa sivua ollaan ja siihen asetetaan offset. Oletuksena 100px.
                var y = $(window).scrollTop();
                $(window).scrollTop(y - offSet);

                // Avataan URL:iin syötetty piilotettava sisältökenttä
                function openSingleToggle() {
                    $("html, body").animate(
                        {
                            scrollTop:
                                $("#" + strippedHash).offset().top - offSet,
                        },
                        animSpeed
                    );
                    $(".target-header")
                        .siblings("#" + strippedHash + "_sibling")
                        .slideToggle(animSpeed, function () {
                            if ($(this).is(":visible"))
                                $(this).css("display", "flex");
                        });
                    if (
                        $("#" + strippedHash)
                            .find(".fa")
                            .hasClass("fa-plus")
                    ) {
                        $("#" + strippedHash)
                            .find(".fa")
                            .removeClass("fa-plus")
                            .addClass("fa-minus");
                    }
                }

                // Kutsutaan openSingleToggle() -funktiota viivellä. Oletuksena viive on 1 sekunti.
                window.setTimeout(openSingleToggle, animSpeed);
            }
        }
    }

    function responsiveVideoIframes() {
        var $allVideos = $(
            "iframe[src*='youtube.com'], iframe[src*='player.vimeo.com']"
        );
        $allVideos.each(function () {
            $(this).wrap("<div class='iframe-flexible-container'></div>");
        });
    }

    // avaa yksittäinen kuva lightboxissa, jos sillä on tietty luokka ja sen linkin url on sama kuin kuvan src
    function openSingleInLightbox() {
        var images = $(
            "img.alignright,img.alignleft,img.aligncenter,img.alignnone,.wp-caption a img"
        ).closest("a");
        $.each(images, function () {
            var imageSrc = this.children[0].src;
            var linkUrl = this.href;
            // jos kuva täysikokoinen niin urlit samat
            if (imageSrc == linkUrl) {
                //$(this).attr('rel', 'lightbox');
                $(this).addClass("tosrus-lightbox");
            }

            //jos kuva linkkaa kuvan pienennettyyn versioon,
            //trimmataan polkujen loppuosat pois mukaanlukien viivalla merkitty
            //koko ja verrataan jäljelle jääneitä polkuja
            else {
                var imageSrc = imageSrc.substring(0, imageSrc.lastIndexOf("-"));
                var linkUrl = linkUrl.substring(0, linkUrl.lastIndexOf("."));
                if (imageSrc == linkUrl) {
                    //$(this).attr('rel', 'lightbox');
                    $(this).addClass("tosrus-lightbox");
                }
            }
        });
    }

    // Theme Lightbox for images
    function tosrusLightbox() {
        $(".gallery-item .gallery-icon a").each(function () {
            $(this).addClass("tosrus-lightbox");
            //$(this).attr("rel", "lightbox");
        });

        // Yksittäisen kuvan linkille title kuvatekstistä
        $(".wp-caption-text:not(.gallery-caption)").each(function () {
            $caption = $(this).text();
            $link = $(this).siblings("a");
            $($link).attr("title", $caption);
        });

        // Gallerian kuvan linkille title kuvatekstistä
        $(".gallery-item .gallery-caption").each(function () {
            $caption = $(this).text();
            $trimcaption = $.trim($caption);
            $link = $(this).siblings().children("a");
            $($link).attr("title", $trimcaption);
        });

        $(".tosrus-lightbox").tosrus(
            {
                //	default options (for both desktop and touch-devices)
                autoplay: {
                    play: false,
                    pauseOnHover: false,
                    timeout: "4000",
                },
                buttons: {
                    prev: true,
                    next: true,
                    close: true,
                },
                caption: {
                    add: true,
                    //target
                    attributes: ["title"],
                },
                //drag : true, //true,
                effect: "slide", //"fade"
                infinite: true,
                keys: {
                    prev: true,
                    next: true,
                    close: true,
                },
                pagination: {
                    add: true,
                    //target : null,
                    type: "thumbnails", //"bullets"
                    //anchorBuilder
                },
                show: true,
                /*
                slides : {
                },
                */
                wrapper: {
                    classes: "",
                    onClick: "close", //"toggleUI"
                    //target
                },
                /*
                youtube / vimeo : {
                },
                */
            },
            {
                //	options only for desktop
                drag: false, //true,
            },
            {
                //	options only touch-devices
                drag: true, //false,
            }
        );
    }

    // Toggle Content - piilotettava sisältö
    function toggleContent() {
        $(".toggle-content-menu-header").on("click keydown", function (event) {
            if (
                event.type == "click" ||
                (event.type == "keydown" && event.which == 13) ||
                event.which == 32
            ) {
                $(this)
                    .next(".toggle-content-menu-item-container")
                    .stop()
                    .slideToggle(300, function () {
                        if ($(this).is(":visible"))
                            $(this).css("display", "flex");
                    });

                $(this).attr("aria-expanded", "true");

                if ($(this).find(".fa").hasClass("fa-plus")) {
                    $(this)
                        .find(".fa")
                        .removeClass("fa-plus")
                        .addClass("fa-minus");
                } else {
                    $(this)
                        .find(".fa")
                        .removeClass("fa-minus")
                        .addClass("fa-plus");
                    $(this).attr("aria-expanded", "false");
                }
                return false;
            }
        });
    }

    // Premium Galleria
    function premiumGallery() {
        $(".premium-gallery-item-header").on("click keydown", function (event) {
            if (
                event.type == "click" ||
                (event.type == "keydown" && event.which == 13) ||
                event.which == 32
            ) {
                $(this)
                    .next(".premium-gallery-item-container")
                    .stop()
                    .slideToggle(300, function () {
                        if ($(this).is(":visible"))
                            $(this).css("display", "flex");
                    });

                if ($(this).attr("aria-expanded") == "false") {
                    $(this).attr("aria-expanded", "true");
                } else {
                    $(this).attr("aria-expanded", "false");
                }
                return false;
            }
        });
    }

    // Scroll to top button
    function scrollToTop() {
        $("#scroll-to-top").click(function () {
            $("html,body").animate({ scrollTop: 0 }, 300);
            return false;
        });
    }

    window.mlScrolling = false;

    // Scroll to content button
    function scrollContent() {
        // Scroll content
        $(".scrollcontent").on("click", function (e) {
            var headerOffset = 0;
            if ($(".header-top-bar").css("position") == "fixed") {
                headerOffset = $(".header-top-bar").outerHeight();
            }
            e.preventDefault();
            $("html, body").animate(
                {
                    scrollTop:
                        $($(this).attr("href")).offset().top - headerOffset,
                },
                500,
                "linear"
            );
        });
    }

    // Slick carousel
    function slickCarousel() {
        $(".carousel-item").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
            adaptiveHeight: false,
            draggable: true,
            arrows: false,
            /*responsive: [
                {
                    breakpoint: 1276,
                    settings: {
                        arrows: false,
                    }
                  
                }
            ]*/
        });
    }

    // Form placeholder text labels - float placeholder to top.
    function movePlaceholderToTop() {
        $(document).on(
            "focus",
            "input[type=text], input[type=email], textarea",
            function (e) {
                var placeholder = $(this).attr("placeholder");
                if (placeholder) {
                    $(this).attr("placeholder", $(this).attr("placeholder"));
                    $(this).attr("placeholder", "");
                    $(this)
                        .parent()
                        .append(
                            '<div class="label-top">' + placeholder + "</div>"
                        );
                    $(this).parent().find(".label-top").fadeIn(400);
                }
            }
        );
    }

    // Set default height and widt to logo image
    function setLogoHeightWidth() {
        const logo = document.querySelector(".logo-container .logo-image img");
        if (logo) {
            const logoHeight = logo.clientHeight;
            const logoWidth = logo.clientWidth;

            logo.setAttribute("width", `${logoWidth}`);
            logo.setAttribute("height", `${logoHeight}`);
        }
    }

    setLogoHeightWidth();
    navMenu();
    movePlaceholderToTop();
    openSingleToggleFromUrl();
    responsiveVideoIframes();
    openSingleInLightbox();
    tosrusLightbox();
    premiumGallery();
    toggleContent();
    scrollToTop();
    fixedNav();
    scrollContent();
    slickCarousel();
    new WOW().init();
});
